import actionTypes from "./constants";

export const initialState = {
  anchorEl: null,
  userId: undefined,
  isShowProfileCard: false,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @typescript-eslint/default-param-last
const userProfileCardReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.OPEN_USER_PROFILE_CARD:
      return {
        ...state,
        ...action.payload,
        isShowProfileCard: true,
      };
    case actionTypes.CLOSE_USER_PROFILE_CARD:
      return {
        userId: undefined,
        anchorEl: null,
        isShowProfileCard: false,
      };
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default userProfileCardReducer;
